if (!customElements.get('product-callout')) {
    customElements.define('product-callout', class ProductCallout extends HTMLElement {
        constructor() {
            super()
            this.mobile_query = window.matchMedia('(max-width: 749px)')

            this.dot_product_display = this.querySelectorAll('.dot-product')

            this.addEventListener('mouseover', () => this._onDotHoverEnter(event))  //desktop show on hover
            // this.addEventListener('click', () => this._onDotClick(event))  //desktop show on hover

            const close_buttons = this.querySelectorAll('.dot-product__close')
            close_buttons.forEach(close => {
                close.addEventListener('click', this._hideVisibleProductDisplay.bind(this), true )
            })
        }

        _onDotHoverEnter(event) {
            if(this.mobile_query.matches) return
            if(!event.target.matches('.dots_dot') && !event.target.closest('.dot-product') ){
                if( this.mobile_query.matches ) return // keep visible on mobile
                //on no dots item or product -> hide
                this._hideVisibleProductDisplay()
            } else {
                if (event.target.matches('.dots_dot')) {
                    //add selected if resize to mobile
                    this._selectDot(event.target)
                    this._showProductDisplay(event.target.dataset)
                }

            }
        }
        _onDotClick(event) {
            const clicked_el = event.target

            if(!this.mobile_query.matches || !clicked_el.matches('.dots_dot')) return
            
            //on mobile and dot clicked
            event.preventDefault()
            this._selectDot(clicked_el)
            
            clicked_el.classList.add('selected')
            // this._hideVisibleProductDisplay()
        }

        _showProductDisplay({ top, left, index, productId }) {
            this._hideVisibleProductDisplay()
            const current_product_display = this.dot_product_display[parseInt(index)]

            if(!current_product_display) return

            const target_card = current_product_display.querySelector(`.dot-product__card[data-id="${productId}"]`)

            if(!target_card) return

            const dot_y = parseInt(top)
            const dot_x = parseInt(left)

            //set position of where to come up
            if (dot_y < 33){
                current_product_display.dataset.position = "top"
            } else if(dot_y > 66) {
                current_product_display.dataset.position = "bot"
            } else if (dot_x < 50) {
                current_product_display.dataset.position = "right"
            } else {
                current_product_display.dataset.position = "left"
            }

            current_product_display.style.top = `${top}%`
            current_product_display.style.left = `${left}%`
            target_card.classList.add('in-view')
            current_product_display.classList.add('in-view')
        }
        _hideVisibleProductDisplay(event = false) {
            if(event){
                //event used when clicking close, prevent going to product
                event.preventDefault()
            }
        
            //hide current in-view
            const currently_visible = this.querySelector('.dot-product.in-view')
            const visible_card = this.querySelector('.dot-product__card.in-view')
            currently_visible?.classList.remove('in-view')
            visible_card?.classList.remove('in-view')
        }

        _selectDot(dot) {
            const callout = dot.closest('.product-callout__item ')
            if(!callout) return
            //remove currently selected
            const current_selected_dot = callout.querySelector('.dots_dot.selected')
            if(current_selected_dot) {
                current_selected_dot.classList.remove('selected')
            }

            dot.classList.add('selected')
        }
    })
}